export enum SessionStorage {
  UserLogoutCallbackSession = 'UserLogoutCallbackSession',
  NewsletterSubscribeUserEmail = 'NewsletterSubscribeUserEmail',
  ValidateUser = 'validateUser',
  LastPageBeforeCheckout = 'lastPageBeforeCheckout',
  ScrollToProductRatingFormAfterLogin = 'ScrollToProductRatingFormAfterLogin',
}

export enum LocalStorage {
  LastSearchedApoLocation = 'lastSearchedApoLocation',
  EmailForChange = 'EmailForChange',
  UserUnverified = 'UserUnverified',
  PasswordReset = 'PasswordReset',
  UpdateUserAddressMessage = 'UpdateUserAddressMessage',
  CheckoutStorage = 'CheckoutStorage',
  WasIaAppModalShown = 'wasIaAppModalShown',
  CartStorage = 'cart-storage',
  Vuex = 'vuex',
  ProductEntrypointsList = 'ProductEntrypointsList',
  SelectedPharmacyData = 'selected-pharmacy-data',
  isAgreementForChatUsageAccepted = 'isAgreementForChatUsageAccepted',
}
